import React, { useCallback, useEffect, useState } from 'react'
import styles from './index.module.css'
import Modal from 'react-responsive-modal'
import ModalFooter from '../../../components/ModalFooter/ModalFooter'
import EventType from './EventType'
import { Input, Quill, Select } from '../../../components/ModalInputs'
import { createNotification } from '../../../components/Notifications/Notifications'
import { useDispatch, useSelector } from 'react-redux'
import { createAds, editAds, getAdsById, getEventTypes } from '../../../actions/ads'
import moment from 'moment'
import Confirmation from '../../../components/Confirmation/Confirmation'
import { getCourses } from '../../../actions/common'


const defaultValues = { // значения по умолчанию
    name: '',
    text: ' ',
    text: ' ',
    dnevnik_firstpage_type: 1,
    dnevnik_firstpage_show_days: 1,
    ev_type_id: '',
    kiosk: 1,
    isservice: 1,
    dnevnik: 0,
    cid: ''
};

const Index = ({ type, setType, date }) => {

    const dispatch = useDispatch();

    const [values, setValues] = useState({ ...defaultValues }); // значения формы

    const [isEventType, setIsEventType] = useState(false); // тип события

    const { adsById = defaultValues } = useSelector(state => state.ads); // объявление по ID из store
    const { list: eventTypeList, eventTypeById } = useSelector(state => state.event_type); // тип события
    const { courses } = useSelector(state => state.common); // список курсов
    const coursesPlus = [...courses] // закинул общее вначало списка
    coursesPlus.unshift({ title: "Общее" })

    const [dataTime, setDataTime] = useState(null)

    const error = (fieldName) => {
        if (values[fieldName] === '') return 'Обязательное поле'
        if (values[fieldName].length > 120) return 'Должно быть не более 120 символов'
    }
    useEffect(() => {
        dispatch(getCourses())
    }, [])

    useEffect(() => { // получаем объявление по ID
        if (type && type !== 'ADD') {
            dispatch(getAdsById(type));
        }
        if (eventTypeById === null) { // получаем типы событий
            dispatch(getEventTypes())
        }
        setDataTime(moment().format("YYYY-MM-DDTHH:mm"))
    }, []);

    useEffect(() => {
        if (adsById) {
            setValues(adsById);
        } else {
            setValues(defaultValues);
        }
    }, [adsById]);

    useEffect(() => {
        if (values && values
            ?.dnevnik === 0) {
            setValues({
                ...values,
                dnevnik_firstpage_type: null,
                dnevnik_firstpage_show_days: 0
            })
        } else {
            setValues({
                ...values,
                dnevnik_firstpage_type: 1
            })
        }
    }, [values
        ?.dnevnik]);

    useEffect(() => {
        if (values
            ?.isservice === 0) {
            setValues({
                ...values,
                dnevnik: 0,
                kiosk: 0
            })
        }
    }, [values
        ?.isservice]);

    useEffect(() => {
        if (dataTime) {
            setValues({
                ...values,
                posted: dataTime,
            })
        }
    }, [dataTime]);

    const closeModal = () => { // закрытие модального окна
        setType(null)
        setValues(defaultValues)
        dispatch({ type: 'SET_ADS_BY_ID', payload: null });
    }

    const [confirmClose, setConfirmClose] = useState(false)
    const handleClose = useCallback(() => setConfirmClose(true), [])
    const acceptConfirmation = useCallback(() => { closeModal(); setConfirmClose(false) }, [closeModal])
    const rejectConfirmation = useCallback(() => setConfirmClose(false), [])

    const modalOpen = !!setType; // открытие модального окна

    const handleSubmit = () => { // отправка формы
        if (!values?.name || !values?.text || values?.cid === '') {
            return createNotification('error', 'Заполните все обязательные поля')
        } else {
            if (type && type !== 'ADD') {
                dispatch(editAds({
                    ...values,
                    cid: Number(values
                        ?.cid),
                    dnevnik_firstpage_show_days: Number(values
                        ?.dnevnik_firstpage_show_days),
                    ev_type_id: Number(values.ev_type_id),
                    posted: dataTime
                }, date.from, date.to))
            } else {
                dispatch(createAds({
                    ...values,
                    cid: Number(values
                        ?.cid),
                    dnevnik_firstpage_show_days: Number(values
                        ?.dnevnik_firstpage_show_days),
                    ev_type_id: Number(values.ev_type_id),
                    posted: dataTime
                }, date.from, date.to))
            }
            closeModal()
        }
    }

    const handleChange = (e) => {
        setValues({
            ...values,
            [e.target.name]: e.target.value
        })
    }

    const handleSetTypeEvent = () => {
        setIsEventType(true);
    }


    return (
        <Modal
            close={closeModal}
            open={modalOpen}
            onClose={handleClose}
            closeOnOverlayClick={true}
            closeOnEsc={true}
            center
            showCloseIcon={false}
            animationDuration={1}
            classNames={{
                modal: styles.roomTypesModal
            }}
            style={{
                padding: '0',
                margin: '0'
            }}>
            {!!values &&
                <div className={styles.wrapper}>
                    {isEventType
                        ? <EventType isEventType={isEventType} setIsEventType={setIsEventType} />
                        : <></>}

                    <h1>{(type && type !== 'ADD')
                        ? 'Редактирование '
                        : 'Создание '}
                        объявления</h1>

                    <div className={styles.modalBody}>
                        <div className={styles.top}>
                            <Input
                                name='name'
                                label='Заголовок'
                                error={error('name')}
                                value={values?.name}
                                onChange={(e) => handleChange(e)} />
                            <br />
                            <br />
                            <div>

                                {type !== 'ADD' ?
                                    <Input
                                        name='posted'
                                        label='Дата'
                                        type="datetime-local"
                                        value={moment(values.posted).format("YYYY-MM-DDTHH:mm")}
                                        onChange={(e) => setDataTime(moment(e.target.value).format("YYYY-MM-DDTHH:mm"))}
                                    />
                                    :
                                    <>
                                        <p style={{ color: '#778AAF', fontSize: '13px' }}>Дата</p>
                                        <Input
                                            type="datetime-local"
                                            value={dataTime}
                                            // value="2017-06-01T08:30"
                                            onChange={(e) => setDataTime(moment(e.target.value).format("YYYY-MM-DDTHH:mm"))} />
                                    </>

                                }
                                <br />
                            </div>

                            <br />
                            <Select
                                name='cid'
                                label='Предмет'
                                error={error('cid')}
                                onChange={(e) => handleChange({
                                    target: {
                                        name: 'cid',
                                        value: (e.target.value)
                                    }
                                })}>
                                <option selected={values.cid === ''} value={''}>Выберите предмет</option>

                                {/* не подходит coursesPlus из-за отсутствия id-ка для выбираемоего предмета  */}
                                {coursesPlus
                                    ?.map((item, index) => <option key={item.cid} value={item.cid} selected={item.cid === values.cid}>{item.title}</option>)}
                            </Select>
                            <br />
                            <br />
                            <div className={styles.row}>
                                <Select
                                    name='ev_type_id'
                                    label='Тип события'
                                    style={{ width: '200px' }}
                                    onChange={(e) => handleChange({
                                        target: {
                                            name: 'ev_type_id',
                                            value: eventTypeList
                                                ?.find(item => item.ev_type === e.target.value)
                                                ?.ev_type_id
                                        }
                                    })}>
                                    <option
                                        selected={values
                                            ?.ev_type_id == ''}>Выберите тип</option>
                                    {eventTypeList && eventTypeList
                                        ?.map((item) => <option
                                            key={item
                                                ?.ev_type_id}
                                            selected={item
                                                ?.ev_type_id === values
                                                    ?.ev_type_id}>{item
                                                        ?.ev_type}</option>)}
                                </Select>
                                <div className={styles.edit} onClick={() => handleSetTypeEvent()}>Изменить</div>
                            </div>
                            <br />
                        </div>

                        <div className={styles.row_button}>
                            <div className={styles.row_button_1}>
                                <div className={styles.radio}>
                                    <Input
                                        label='Публичное'
                                        name='radio'
                                        type='radio'
                                        checked={values.isservice == 1}
                                        onChange={() => handleChange({
                                            target: {
                                                name: 'isservice',
                                                value: 1
                                            }
                                        })} />
                                    <Input
                                        label='Отображать на главной странице ЭД как'
                                        name='dnevnik'
                                        type='checkbox'
                                        checked={values.dnevnik !== 0}
                                        onChange={(e) => handleChange({
                                            target: {
                                                name: 'dnevnik',
                                                value: values.dnevnik == 0
                                                    ? 1
                                                    : 0
                                            }
                                        })}
                                        disabled={values.isservice === 0} />
                                </div>
                                <div className={styles.checkbox}>
                                    <Input
                                        label='Служебное'
                                        name='radio'
                                        type='radio'
                                        checked={values.isservice == 0}
                                        onChange={() => handleChange({
                                            target: {
                                                name: 'isservice',
                                                value: 0
                                            }
                                        })} />
                                    <Input
                                        label='Отображать в инф. киоске'
                                        name='kiosk'
                                        type='checkbox'
                                        checked={values.kiosk == 1}
                                        onChange={() => handleChange({
                                            target: {
                                                name: 'kiosk',
                                                value: Number(!values.kiosk)
                                            }
                                        })}
                                        disabled={values.isservice === 0} />
                                </div>
                            </div>

                            <div className={styles.row_button_2}>
                                <div className={styles.row_button_2_inner}>
                                    <Input
                                        label='Новость'
                                        name='dnevnik_firstpage_type'
                                        type='radio'
                                        checked={values.dnevnik_firstpage_type === 1}
                                        onChange={() => handleChange({
                                            target: {
                                                name: 'dnevnik_firstpage_type',
                                                value: 1
                                            }
                                        })}
                                        disabled={values.dnevnik === 0} />
                                    <Input
                                        label='Цитата'
                                        name='dnevnik_firstpage_type'
                                        type='radio'
                                        checked={values.dnevnik_firstpage_type === 2}
                                        onChange={() => handleChange({
                                            target: {
                                                name: 'dnevnik_firstpage_type',
                                                value: 2
                                            }
                                        })}
                                        disabled={values.dnevnik === 0} />
                                </div>
                                <Input
                                    label='Отображать дней'
                                    type='text'
                                    name='dnevnik_firstpage_show_days'
                                    min={1}
                                    max={5}
                                    onChange={(e) => handleChange({
                                        target: {
                                            name: 'dnevnik_firstpage_show_days',

                                            value: /^(?!0\d)\d{1,5}$/.test((e.target.value))
                                                ? e.target.value
                                                : e
                                                    .target
                                                    .value
                                                    .slice(5, 0)
                                        }
                                    })}
                                    value={values.dnevnik_firstpage_show_days}
                                    disabled={values.dnevnik === 0} />
                            </div>
                        </div>
                        <br />

                        <div className={styles.quill}>
                            <Quill
                                label='Текст объявления'
                                value={values.text}
                                name='text'
                                error={error('text')}
                                style={{
                                    height: '200px'
                                }}
                                onChange={(e) => handleChange({
                                    target: {
                                        name: 'text',
                                        value: e
                                    }
                                })}
                            />
                        </div>
                    </div>
                </div>
            }

            <div className={styles.modalFooter}>
                <ModalFooter
                    isShowInfo={false}
                    handleSubmit={handleSubmit}
                    closeModal={closeModal} />
            </div>
            {confirmClose && (
                <Confirmation
                    title="Закрыть без сохранения изменений?"
                    acceptConfirmation={acceptConfirmation}
                    rejectConfirmation={rejectConfirmation}
                />
            )}
        </Modal>
    )
}

export default Index
